import { createRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { authenticatedRoute } from '@/authenticated-route';
import { beforeLoadRouterGuard } from '@/integrations/tanstack-router/before-load-router-guard';
import { ACCOUNT_MAINTENANCE_ROUTES } from './consts/routes';
import { accountMaintenanceSearchSchema } from './types';

export const accountMaintenanceRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: ACCOUNT_MAINTENANCE_ROUTES.index,
  beforeLoad: beforeLoadRouterGuard([], {
    featureFlag: 'userManagementEnabled',
  }),
  validateSearch: zodValidator(accountMaintenanceSearchSchema),
}).lazy(() => import('./account-maintenance').then(({ Route }) => Route));
